(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["svp-instant-faq-contact-form-section"] && !Shopify.designMode) return;
  try {
    
    function attachEventListeners() {
      let errorEl = document.getElementById('svp-instant-faq-contact-form-error-box');
      let contactFormEmailElement = document.getElementById('contactFormEmail');
      contactFormEmailElement.addEventListener('blur', validateEmailAddress);
    }
    function validateEmailAddress(){
      let contactFormEmail = document.getElementById('contactFormEmail').value;
      let customErrorBoxElement = document.getElementById('svp-instant-faq-contact-form-error-box');
      let submitButtonElement = document.getElementById('contactFormSubmit');
      let emailValidated = false;
      console.log(contactFormEmail);
      if(contactFormEmail.includes("@")){
        let atSymbolIndex = contactFormEmail.indexOf('@');
        let domainSection = contactFormEmail.slice(atSymbolIndex);
        if(domainSection.includes(".")){
          emailValidated = true;
        }
      }
      if(!emailValidated){
        submitButtonElement.value = "Please enter a valid email address";
        customErrorBoxElement.style.display = 'block';
        customErrorBoxElement.innerHTML = "Please enter a valid email address";
      } else {
        submitButtonElement.value = "Send";
        customErrorBoxElement.style.display = 'none';
      }
  
    }
    attachEventListeners();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svp-volume-contact-form"] && !Shopify.designMode) return;
  try {
    
    function attachEventListeners() {
      let errorEl = document.getElementById('contact-form-error-box');
      let contactFormEmailElement = document.getElementById('contactFormEmail');
      contactFormEmailElement.addEventListener('blur', validateEmailAddress);
    }
    function validateEmailAddress(){
      let contactFormEmail = document.getElementById('contactFormEmail').value;
      let customErrorBoxElement = document.getElementById('contact-form-error-box');
      let submitButtonElement = document.getElementById('contactFormSubmit');
      let emailValidated = false;
      if(contactFormEmail.includes("@")){
        let atSymbolIndex = contactFormEmail.indexOf('@');
        let domainSection = contactFormEmail.slice(atSymbolIndex);
        if(domainSection.includes(".")){
          emailValidated = true;
        }
      }
      if(!emailValidated){
        submitButtonElement.value = "Please enter a valid email address";
        customErrorBoxElement.style.display = 'block';
        customErrorBoxElement.innerHTML = "Please enter a valid email address";
      } else {
        submitButtonElement.value = "Send";
        customErrorBoxElement.style.display = 'none';
      }
  
    }
    attachEventListeners();

  } catch(e) { console.error(e); }
})();
})();
